import jquery from 'jquery';
import * as bootstrap from 'bootstrap';
import Cookie from 'js-cookie';
import Helpers from '@wielink-application/shared/js/helpers/Helpers';
import {router} from '@inertiajs/vue3';

window.Helpers = Helpers;
window.jquery = window.jQuery = window.$ = jquery;
window.bootstrap = bootstrap;

$.ajaxPrefilter((options, originalOptions, jqXHR) => {
	jqXHR.setRequestHeader('X-XSRF-TOKEN', Cookie.get('XSRF-TOKEN'));
});

window.handleRedirect = (url) => {
	router.get(url);
}